module.exports = __webpack_public_path__ + "static/media/refresh_icon.bf4b6358.svg";